<template>
    <div v-if="showInfoModal">
        <b-modal v-model="showInfoModal"
                 :content-class=" 'custom-modal ' + (settings.sectionClass ? settings.sectionClass : '')">
            <template v-slot:modal-header="{ close }">
                <span class="close-icon" @click="onClose"></span>
            </template>
            <div>
                <label>Place id</label>
                <b-form-input id="place_id" type="number" v-model="siteId" placeholder="site id"></b-form-input>
            </div>
            <div>
                <input
                    type="file"
                    @change="onFileSelected"
                    ref="fileInput"
                >
            </div>

            <template v-slot:modal-footer>
                <div class="footerButton__wrapper">
                    <a v-if="!settings.hideOkButton" class="onOk__btn" @click="runImport">
                        <div>
                            <b-spinner v-if="uploadSpinner" small></b-spinner>
                            <span v-else>Run Import</span>
                        </div>
                    </a>
                </div>

            </template>

        </b-modal>
    </div>
</template>

<script>
    import _ from "lodash";
    import errorMixin from '@/mixins/errorMixin';
    import logAnalyticsEvent, {logError} from "@/helpers/analytics";
    import {mapActions} from "vuex";

    export default {
        name: 'customModalPopap',

        mixins: [errorMixin],

        data() {
            return {
                showInfoModal: !_.isEmpty(this.settings),
                uploadSpinner: false,
                siteId: '',
            }
        },

        watch: {
            settings(newValue) {
                this.showInfoModal = !_.isEmpty(newValue)
            }
        },

        props: {
            settings: {
                type: [Object, null],
                default: () => {
                    return {
                        windowWidth: null,
                    }
                }
            },
        },

        methods: {

            ...mapActions({
                importCro: 'question/importCro',
            }),


            async onClose() {
                this.showInfoModal = false
                if (this.settings.onCancelHandler) {
                    try {
                        await this.settings.onCancelHandler(this.settings)
                    } catch (error) {
                        this.showErrorModal(error.message)
                    }
                }
            },

            async onFileSelected(e) {
                this.selectedFile = e.target.files || e.dataTransfer.files;
            },

            async runImport(e) {
                if(this.siteId == '') {
                    this.showErrorModal('please enter site id')
                    return
                }
                if(!this.selectedFile || !this.selectedFile[0]) {
                    this.showErrorModal('please choose a file')
                    return
                }
                this.uploadSpinner = true
                try {
                    const response = await this.importCro({
                        siteId: this.siteId,
                        file: this.selectedFile[0],
                    });
                    this.showInfoModal = false
                } catch (e) {
                    console.log('error', e)
                    this.showErrorModal(e.data.error.message, {
                        title: 'Error',
                        code: e.data.error.code
                    })
                } finally {
                    this.uploadSpinner = false
                }
            },

        },
    }
</script>

<style>

    .modal-secondary-text {
        font-size: 12px;
        font-weight: 700;
        margin-top: 15px;
    }
    .popapButton-wrapper {
        display: flex;
        justify-content: space-between;
        padding: 13px 0 0 15px;
        flex-direction: column;
    }
    .popapButton-panel {
        width: 576px;
        height: 136px;
        padding: 24px 0px 16px 32px;
        background-color: #F7F7F7;
        cursor: pointer;
        margin-bottom: 16px;
        display: flex;
        align-items: center;
    }
    .popapButton-panel.active {
        border: 4px solid #2F2F2F;
        border-radius: 3.33px;
        padding: 20px 0px 12px 28px;

    }

    .modal-panelIcon {
        height: 80px;
        width: 160px;
        background-repeat: no-repeat;
        background-size: 100%;
        margin-bottom: 24px;
        transition: 0.2s linear;
        margin-top: 15px;
    }
    .modal-panelIcon__business {
        height: 97px;
        width: 158px;
        border-radius: 2.22px;
        background-repeat: no-repeat;
        background-size: 100%;
    }
    .modal-panelIcon__extended {
        height: 104px;
        width: 160px;
        border-radius: 4px;
        background-repeat: no-repeat;
        background-size: 100%;
    }
    .modal-panelText {
        font-weight: 700;
    }
    .modal-panelSubtitle {
        width: 344px;
        color: #2F2F2F;
        font-family: Nunito;
        font-weight: 500;
        font-size: 14px;
        letter-spacing: 0;
        line-height: 20px;
    }
    .modal-textWrapper {
        text-align: start;
        padding-left: 25px;
    }
    @media screen and (max-width: 426px) {
        .popapButton-wrapper {
            display: flex;
            align-items: center;
            flex-direction: column;
            padding: 13px 0 0 64px
        }

        .popapButton-panel {
           margin-bottom: 12px;
        }


    }
    

    .custom-modal.leftAlign .modal-input {
        text-align: left;
    }

    .custom-modal .close-icon {
        position: static;
        cursor: pointer;
        width: 28px;
        height: 28px;
        background: url('../../assets/icons/ic_close_white.svg') 50% no-repeat;
    }

    .custom-modal .modal-title {
        font-size: 18px;
        font-weight: bold;
        color: #2F2F2F;
        text-align: center;
    }

    .custom-modal .modal-header {
        text-align: center;
        border: none;
        justify-content: flex-end;
        padding-bottom: 0;
    }

    .custom-modal.welcome-modal .modal-footer {
        flex-direction: column;
    }

    .custom-modal.welcome-modal .modal-footer > * {
        width: 100%;
        margin: 5px 0;
        text-decoration: none;
    }

    .custom-modal .modal-footer a {
        text-decoration: none;
    }

    .custom-modal .modal-footer {
        border: none;
    }

    .custom-modal .modal-message {
        width: 448px;
        color: #2F2F2F;
        font-family: Nunito;
        font-size: 16px;
        letter-spacing: 0;
        line-height: 24px;
    }

    .custom-modal {
        text-align: center;
        width: 640px;
    }

    .modal-input {
        margin-top: 15px;
    }

    .modal-input input:focus {
        border-color: #2F2F2F;
        box-shadow: 0 0 0 0.2rem rgba(47, 47, 47, 0.25);
    }

    .custom-modal .btn {
        min-width: 140px;
        padding: 10px 12px;
        border-radius: 0;
        border: none;
        font-size: 14px;
        font-weight: bold;
        width: 100%;
    }

    .custom-modal .modal-icon {
        width: 56px;
        height: 56px;
        margin: 0 auto;
        background-size: cover;
        margin-bottom: 15px;
    }
    .custom-modal .popapButton-icon {
        height: 96px;
        background-size: cover;
    }

    .custom-modal .btn.btn-primary {
        background: #2F2F2F;
        color: #ffffff;
    }
    .footerButton__wrapper {
        display: flex;
        width: 100%;
    }
    .onOk__btn {
        width: 100%;
        color: #FFFFFF !important;
        font-family: Nunito;
        font-size: 16px;
        font-weight: 700;
        letter-spacing: 0;
        line-height: 24px;
        border-radius: 6px;
        background-color: #3F405C;
        text-align: center;
        padding-top: 11px;
        cursor: pointer;
        height: 48px
    }
    .cancel__btn {
        width: 100%;
        padding-top: 11px;
        cursor: pointer;
        border: 2px solid #3F405C;
        border-radius: 6px;
        color: #3F405C;
        font-family: Nunito;
        font-size: 16px;
        font-weight: 700;
        letter-spacing: 0;
        line-height: 24px;
        margin-right: 16px;
    }
    
    
    /**/
    .full-width--btn.large {
        min-width: 40vw;
        font-size: 0.7vw;
        transform: translateX(-50%);
        left: 50%;
    }

    .full-width--btn.large.custom-modal .modal-message {
        width: 90%;
    }

    .full-width--btn.custom-modal .btn {
        width: 100%;
    }
    @media screen and (max-width: 1024px) {
        .custom-modal {
            width: 600px;
        }
        .popapButton-panel {
            width: 530px;
        }
        .modal-panelIcon {
            margin-top: 32px;
        }
        .modal-panelIcon__extended {
            margin-top: 15px;
        }
        .modal-panelIcon__business {
            margin-top: 15px;
        }
    }
    @media screen and (max-width: 1000px) {
        .full-width--btn.custom-modal .modal-footer button {
            width: 100%;
            margin: 0;
            margin-top: 3vw;
        }

        .full-width--btn.custom-modal .modal-footer {
            border: none;
            flex-direction: column-reverse;
            /* width: 100%; */
        }
    }
    @media screen and (max-width: 768px) {
        .custom-modal {
            width: 550px;
        }
        .popapButton-panel {
            width: 480px;
        }
        .popapButton-panel {
            padding: 14px 8px 8px 9px;
        }
        .popapButton-panel.active {
            padding: 10px 4px 4px 5px;
        }
        .modal-textWrapper {
            padding-left: 5px;
        }
        .modal-panelIcon {
            margin-top: 45px;
        }
        .modal-panelIcon__extended {
            margin-top: 25px;
        }
        .modal-panelIcon__business {
            margin-top: 23px;
        }
    }
    @media screen and (max-width: 426px) {
        .custom-modal {
            width: auto;
        }
        .modal-panelSubtitle {
            display: none;
        }
        .popapButton-panel {
            width: auto;
            display: flex;
            flex-direction: column;
            height: auto;
        }
        .popapButton-wrapper {
            padding: 13px 0 0 0;
        }
        .modal-panelIcon {
            margin-top: 0;
            margin-bottom: 15px;
        }
        .modal-panelIcon__extended {
            margin-top: 0;
            margin-bottom: 15px;
        }
        .modal-panelIcon__business {
            margin-top: 0;
            margin-bottom: 15px;
        }
    }
</style>